import { cx } from '@/lib/cx';

/** Selo da marca: carimbo de "conferido". Cor via currentColor — troca com os tokens do cliente. */
export function Marca({
  nome,
  compacta = false,
  className,
}: {
  nome: string;
  compacta?: boolean;
  className?: string;
}) {
  return (
    <span className={cx('inline-flex items-center gap-2.5 text-marca', className)}>
      <svg viewBox="0 0 32 32" className="size-7 shrink-0 -rotate-6" aria-hidden>
        <circle cx="16" cy="16" r="13" fill="none" stroke="currentColor" strokeWidth="2.2" />
        <circle
          cx="16"
          cy="16"
          r="9.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.55"
        />
        <path
          d="M11.6 16.4l3.1 3.1 5.9-6.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {!compacta && (
        <span className="truncate text-lg font-bold tracking-tight text-texto">{nome}</span>
      )}
    </span>
  );
}
